export const environment = {
  production: true,
  baseUrl:'http://sistemalegal.spem.com.mx',
  token:'f2f9ca33aa0982c8b58d0422d1f5f3fa'
};
